export default __webpack_public_path__ + "static/media/IMG_20200809_181556_480.fce98b6a.jpg";